import Index from './pages/index'
import Login from './pages/login'
import Layout from './pages/layout'
import Notfound from './pages/notfound'
import Basic from './pages/basic/index'
import PdaMenu from './pages/pdaMenu.vue'
import System from './pages/system/index'
import MenuConfig from './pages/basic/menuConfig/index'
import Configs from './pages/configs/index'
import PrinterManagement from './pages/basic/printerManagement/index.vue'
import CreateQRCode from './pages/basic/createQRCode/index.vue'
import CostManagement from './pages/basic/costManagement/index'
import commProbMana from './pages/basic/commProbMana/index'
import operationLargeScreen from './pages/basic/operationLargeScreen/index'
import commonProblem from './pages/basic/commonProblem/index'
import updateLogManagement from './pages/basic/updateLogManagement/index';
import updateLogs from './pages/basic/updateLogs/index'
import Portal from './pages/portal.vue'
// 人员管理
// import PersonIndex from './pages/basic/person/index'
// import PersonEdit from './pages/basic/person/edit'
// 流程配置
import FunctionConfig from './pages/basic/functionConfig/index'
import FunctionConfigEdit from './pages/basic/functionConfig/edit'
// 字典配置
import DictConfig from './pages/basic/dictConfig/index'
import DictConfigEdit from './pages/basic/dictConfig/edit'
// 篮筐推车管理
import ContainerIndex from './pages/basic/container/index'
import ContainerEdit from './pages/basic/container/edit'
// 设备管理
import MachineIndex from './pages/basic/machine/index'
import MachineEdit from './pages/basic/machine/edit'
// 器械包管理
import InstrumentPackage from './pages/basic/instrumentPackage/index'
import InstrumentPackageEdit from './pages/basic/instrumentPackage/edit'
//器械管理
import InstrumentIndex from './pages/basic/instrument/index'
import InstrumentEdit from './pages/basic/instrument/edit'
//科室、科室组管理
import DepartmentIndex from './pages/basic/department/index'
//供应商管理
import VendorsIndex from './pages/basic/vendors/index'
import VendorsEdit from './pages/basic/vendors/edit'
//耗材管理
import DisposablesIndex from './pages/basic/disposables/index'
import DisposablesEdit from './pages/basic/disposables/edit'
//模板管理
import TemplateIndex from './pages/basic/template/index'
// 基础信息图表页
import BasicInformation from './pages/basic/basicInformation/index'
// 公告通知
import AnnouncementNotice from './pages/basic/announcementNotice'
// 器械类管理
import InstrumentPart from './pages/basic/instrumentPart/index'
//修改密码
import changePasswordIndex from './pages/basic/changePassword/index'
// 系统配置（后端和实施使用）
import SysConfig from './pages/sysConfig/index'
//无菌包有效期管理
const ValidationManagement = ()=>import(/* webpackChunkName: "ValidationManagement" */'./pages/basic/validationManagement/index.vue')
// 租户管理
const TenantList = () => import('./pages/basic/tenantManagement/index.vue')

// 用户管理
const UserList = () => import('./pages/basic/userManagement/index.vue')

// 经销商管理
const dealerList = () => import('./pages/basic/dealerManagement/index.vue')

// 轮播图管理
const Swiper = () => import('./pages/configs/swiper/index.vue')

// 系统
import contract from './pages/system/contract/index'

// 标签设计模块
import TagBase from './pages/tag/index'
// 模版列表
import TagList from './pages/tag/list/index'
// 模版设计页
import TagTemplateEdit from './pages/tag/template/index'
// 模版打印页
import TagPrint from './pages/tag/print/index'
// 打印记录页
import TagPrintRecord from './pages/tag/statistic/record'
// 打印统计图表页
import TagPrintRecordChart from './pages/tag/statistic/chart'
// 字典管理页面
import dictManagement from './pages/basic/dictManagement/index'
// 字典类型管理页面
import dictType from './pages/basic/dictType/index'

export default [
  {
    path: '/',
    component: Layout,
    children: [
      // 首页
      {
        path: '/index',
        component: Index
      },
      // pda菜单页
      {
        path: '/pda-menu',
        component: PdaMenu
      },
      // 基础数据
      {
        path: '/basic/',
        component: Basic,
        children: [
          // 人员管理
          // {
          //   path: 'person/index',
          //   component: PersonIndex
          // },
          // {
          //   path: 'person/edit/:id',
          //   component: PersonEdit
          // },
          // 公告通知
          {
            path: 'announcementNotice/index',
            component: AnnouncementNotice
          },
          // 流程配置
          {
            path: 'function/index',
            component: FunctionConfig
          },
          // 打印机管理
          {
            path: 'printerManagement/index',
            component: PrinterManagement
          },
          // 二维码制作模块
          {
            path: 'createQRCode/index',
            component: CreateQRCode
          },
          // 成本管理
          {
            path: 'costManagement/index',
            component: CostManagement
          },
          {
            path: 'function/edit/:id',
            component: FunctionConfigEdit
          },
          // 字典配置
          {
            path: 'dict/index',
            component: DictConfig
          },
          {
            path: 'dict/edit/:id',
            component: DictConfigEdit
          },
          // 篮筐推车管理
          {
            path: 'container/index',
            component: ContainerIndex
          },
          {
            path: 'container/edit/:id',
            component: ContainerEdit
          },
          // 设备管理
          {
            path: 'machine/index',
            component: MachineIndex
          },
          {
            path: 'machine/edit/:id',
            component: MachineEdit
          },
          // 器械包管理
          {
            path: 'instrument-package/index',
            component: InstrumentPackage
          },
          {
            path: 'instrument-package/edit/:id',
            component: InstrumentPackageEdit
          },
          //器械管理
          {
            path: 'instrument/index',
            component: InstrumentIndex
          },
          {
            path: 'instrument/edit/:id',
            component: InstrumentEdit
          },
          //科室管理
          {
            path: 'department/index',
            component: DepartmentIndex
          },
          //供应商管理
          {
            path: 'vendors/index',
            component: VendorsIndex
          },
          {
            path: 'vendors/edit/:id',
            component: VendorsEdit
          },
          //耗材管理
          {
            path: 'disposables/index',
            component: DisposablesIndex
          },
          {
            path: 'disposables/edit/:id',
            component: DisposablesEdit
          },
          //模板管理
          {
            path: 'depttemplete/index',
            component: TemplateIndex
          },
          //基础信息图表页
          {
            path: 'basicInformation/index',
            component: BasicInformation
          },
          // 菜单管理
          {
            path: 'menu-config/index',
            component: MenuConfig
          },
          // 器械类管理
          {
            path: 'instrumentpart/index',
            component: InstrumentPart
          },
          //修改密码
          {
            path: 'changePassword/index',
            component: changePasswordIndex
          },
          // 基数管理
          {
            path: 'cardinal/index',
            component: () => import('@/pages/basic/cardinal/index')
          },
          //无菌包有效期管理
          {
            path: 'validationManagement/index',
            component: ValidationManagement
          },
          // 租户管理列表
          {
            path: 'tenant/index',
            component: TenantList
          },
          // 租户管理列表
          {
            path: 'user/index',
            component: UserList
          },
          {
            path: 'dealer/index',
            component: dealerList
          },
          { // 常用问题管理
            path: 'commProbMana/index',
            component: commProbMana
          },
          { // 标签管家运营大屏
            path: 'operationLargeScreen/index',
            component: operationLargeScreen
          },
          { // 常见问题
            path: 'commonProblem/index',
            component: commonProblem
          },
          { // 管理更新日志
            path: 'updateLogManagement/index',
            component: updateLogManagement
          },
          { // 更新日志
            path: 'updateLogs/index',
            component: updateLogs
          },
          { // 字典管理
            path: 'dictManagement/index',
            component: dictManagement
          },
          { // 字典类型
            path: 'dictType/index/:id',
            component: dictType
          },
        ]
      },
      {
        path: '/config/',
        component: Configs,
        children: [
          {
            path: 'swiper/index',
            component: Swiper
          }
        ]
      },
      {
        path: '/system/',
        component: System,
        children: [
          // 联系方式
          {
            path: 'contract/index',
            component: contract
          }
        ]
      },
      {
        // 标签模块
        path: '/tag/',
        component: TagBase,
        children: [
          {
            path: 'list/index',
            component: TagList
          },
          {
            path: 'template/index/:id',
            component: TagTemplateEdit
          },
          {
            path: 'print/index/:id',
            component: TagPrint
          },
          {
            path: 'statistic/record',
            component: TagPrintRecord
          },
          {
            path: 'statistic/chart',
            component: TagPrintRecordChart
          }
        ]
      },
    ]
  },
  {
    path: '/portal',
    component: Portal
  },
  {
    path: '/sys-config',
    component: SysConfig
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '*',
    component: Notfound
  }
]